import { useMemo } from "react";
import { Group, Stack, Space, Checkbox } from "@mantine/core";
import { Text } from "@/components/ui/Text";
import { AssignmentItemTimeProgress } from "./AssignmentItemTimeProgress";
import {
  useIsPlaylistCompleted,
  useTotalPlaylistVideoSeconds,
} from "@/store/selectors/playlistSelectors";
import { useTotalSecondsWatchedOfPlaylistVideos } from "@/store/selectors/userProfileSelectors";
import { IconArrowRight } from "@tabler/icons-react";
import { AssignmentService } from "@/services/AssignmentService";

export const PlaylistCheckbox = ({
  playlistId,
  title,
  isPlaylistCompleted,
  isSmall = false,
  userVideoData,
}: {
  playlistId?: string;
  title?: string;
  isPlaylistCompleted?: boolean;
  isSmall?: boolean;
  userVideoData: any;
  userPlaylistData: any;
  playlistData?: ReturnType<
    typeof AssignmentService.getUserRankedPlaylistsWatchedData
  >[number];
}) => {
  const isPlaylistCompletedForActiveUser = useIsPlaylistCompleted(
    playlistId || "",
  );
  const totalPlaylistVideoSeconds = useTotalPlaylistVideoSeconds(playlistId);
  const totalSecondsWatchedOfPlaylistVideos =
    useTotalSecondsWatchedOfPlaylistVideos({
      playlistId: playlistId || "",
      userVideoData,
    });

  const isPlaylistCompletedFinal = useMemo(() => {
    if (typeof isPlaylistCompleted === "boolean") {
      return isPlaylistCompleted;
    }
    return isPlaylistCompletedForActiveUser;
  }, [isPlaylistCompleted, isPlaylistCompletedForActiveUser]);

  return (
    <Group
      flex={1}
      gap={0}
      opacity={isPlaylistCompletedFinal ? 0.7 : 1}
      align="flex-start"
    >
      <Checkbox
        color="primary"
        size={isSmall ? "xs" : "md"}
        readOnly
        checked={isPlaylistCompletedFinal}
      />
      <Space w="md" />
      {/* <ResourceConfigs.playlist.Icon
          size={isSmall ? 18 : 32}
          color={theme.colors.text[8]}
        /> */}
      <Stack gap={0} pl={8} flex={1}>
        {!playlistId ? (
          isSmall ? (
            <Text size="xs" c="text.5">
              No playlist started yet
            </Text>
          ) : (
            <a
              href={`/playlists`}
              target="_blank"
              style={{
                flex: 1,
                alignItems: "center",
                width: "100%",
                display: "flex",
              }}
            >
              <Text
                titleStyle={isSmall ? "h6" : "h5"}
                lh={1.2}
                fw={500}
                c="primary"
                style={{ display: "flex", alignItems: "center", gap: 4 }}
              >
                Find a playlist to fill this spot
                <IconArrowRight size={20} style={{ marginLeft: 4 }} />
              </Text>
            </a>
          )
        ) : (
          <a href={`/playlists/${playlistId}`} target="_blank">
            <Text
              titleStyle={isSmall ? "h6" : "h5"}
              lh={1.2}
              fw={isSmall ? 500 : 700}
              c="text.8"
            >
              {title}
            </Text>
          </a>
        )}

        {!playlistId ? null : (
          <>
            <Space h={4} />
            <AssignmentItemTimeProgress
              totalSecondsWatched={totalSecondsWatchedOfPlaylistVideos}
              totalSecondsRequired={totalPlaylistVideoSeconds}
              isSmall={isSmall}
            />
            <Space h={4} />
          </>
        )}
      </Stack>
    </Group>
  );
};
